export default __webpack_public_path__ + "static/media/chevron_rightHealthgenom.1a8aa0db.svg";